<template>
  <div id="app">
    <router-view />

    <md-dialog
      :md-active.sync="showNoiAlert"
      :md-close-on-esc="false"
      :md-click-outside-to-close="false"
      class="noi-alert"
    >
      <md-dialog-title>Action required</md-dialog-title>

      <p class="md-title">You need to update your account</p>

      <md-dialog-actions>
        <md-button class="md-primary" @click="updateAccount">
          Take me there!
        </md-button>
      </md-dialog-actions>
    </md-dialog>

    <md-dialog
      :md-active.sync="showMaintenanceNotice"
      class="maintenance-notice"
    >
      <md-dialog-title>Scheduled Maintenance</md-dialog-title>

      <div class="md-dialog-content">
        <p>
          Songfile will be offline for scheduled maintenance this weekend.
        </p>
        <p>
          <strong>Downtime window</strong><br />
          Starts: Friday, September 11 at 6:00 PM ET<br />
          Ends: Monday, September 14 at 8:00 AM ET
        </p>
        <p>
          During this window, you will not be able to access or submit anything
          in Songfile. Any work in progress should be saved and submitted before
          6:00 PM Friday. We appreciate your patience and understanding.
        </p>
      </div>

      <md-dialog-actions>
        <md-button class="md-primary" @click="showMaintenanceNotice = false">
          Got it
        </md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import { isBeforeMaintenanceStart } from "@/services/maintenance";

export default {
  name: "App",
  metaInfo: function() {
    return {
      titleTemplate: "Songfile%s"
    };
  },
  data: function() {
    return {
      showNoiAlert: false,
      showMaintenanceNotice: false
    };
  },
  computed: {
    isNoiReady() {
      return this.$store.getters["auth/isNOIReady"];
    }
  },
  watch: {
    // eslint-disable-next-line prettier/prettier
    "$route": function() {
      this.openNoiAlert();
    },
    isNoiReady: function(value) {
      this.openNoiAlert();
    }
  },
  methods: {
    updateAccount: function() {
      this.$router.push({ name: "my-profile" });
      this.showNoiAlert = false;
    },
    openNoiAlert: function() {
      if (
        !this.isNoiReady &&
        this.$route.name != null &&
        this.$route.name != "my-profile"
      ) {
        this.showNoiAlert = true;
      }
    }
  },
  mounted: function() {
    this.openNoiAlert();
    this.$cookiebot.consentBanner();

    // Skip when PrerenderSPAPlugin (via headless Chrome) is snapshotting
    // this page at build time: the popup would get baked into the static
    // HTML with no JS attached yet, so a real visitor could click "Got it"
    // before the app finishes loading and have it silently do nothing.
    if (!/HeadlessChrome/.test(navigator.userAgent)) {
      this.showMaintenanceNotice = isBeforeMaintenanceStart();
    }
  }
};
</script>

<style lang="scss">
.test-msg {
  z-index: 99999999;
  position: absolute;
  top: 50%;
}
.noi-alert {
  .md-title {
    padding: 20px;
  }
}
.noi-alert + .md-dialog-overlay {
  z-index: 10;
}
.maintenance-notice {
  // render above the noi-alert dialog (z-index: 11) if both happen to be
  // active at once
  z-index: 12;

  .md-dialog-title {
    padding: 20px 24px 0;
  }
  .md-dialog-content {
    padding: 16px 24px;

    p {
      color: #222;
    }
  }
}
</style>
